module.exports = __webpack_public_path__ + "img/warning.4ec2ef0f.svg";